import { useAppDispatch, useAppSelector } from "app/hooks"
import { useEffect, useState } from "react"
import { getProfile } from "../profileSlice"
import { IProfile } from "../profileTypes"

export const useProfile = () => {
  const profile = useAppSelector((state) => state.profile.profile)
  const getProfileLoading = useAppSelector(
    (state) => state.profile.getProfileLoading,
  )
  const getProfileFailed = useAppSelector(
    (state) => state.profile.getProfileFailed,
  )

  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(getProfile())
  }, [])

  return { profile, getProfileLoading, getProfileFailed }
}

export const useProfileForm = (initProfile?: IProfile) => {
  const [name, setName] = useState(initProfile?.name || "")
  const [birthedOn, setBirthedOn] = useState(
    initProfile?.profile.birthedOn || "",
  )

  const [gender, setGender] = useState(initProfile?.profile.gender)

  useEffect(() => {
    if (initProfile) {
      setName(initProfile.name)
      setBirthedOn(initProfile.profile.birthedOn)
    }
  }, [initProfile])

  return { name, setName, birthedOn, setBirthedOn, gender, setGender }
}
